import { PaymentPlans } from "./PaymentPlans";
import Footer from "../../public/Footer";
import Header from "../Header";
import { useEffect } from "react";

export const Payment = () => {
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])
  return (
    <div className="bg-[#ebf0f3] ">
      <Header />
      <div className="max-w-[1280px] mx-auto mt-1 px-4">
        {/* TIP-493 — /plans is now the focused Buy-a-Web-Profile checkout. */}
        <PaymentPlans />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};
